// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3c638c4d","977":"fbc8f8f7"}[chunkId] + ".chunk.js";
};